/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines the iOn Suite Application keys which are to be used for all iOn specific
 * constant references, such as when initializing User Preferences, getting / setting
 * localStorage values, etc.
 */
export enum ApplicationKeys {
  iOnSuite = 'ion-suite',
  iOnSuiteSession = 'ion-suite-session',
  iOnSuitePage = 'ion-suite-page'
};
